// src/SkillsList.js
import React from "react";
import { List, Image, Space, Col } from "antd";
import { SKILLS_DATA } from "../constants";

const SkillsList = () => {
  return (
    <List
      grid={{
        gutter: 16,
        xs: 2,
        sm: 3,
        md: 4,
        lg: 5,
        xl: 6,
        xxl: 6,
      }}
      dataSource={SKILLS_DATA}
      renderItem={(item) => (
        <List.Item
          style={{
            display: "flex",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "white",
            position: "relative",
            transition: "box-shadow 0.3s ease",
            paddingTop: "4px",
            paddingBottom: "4px",
            paddingLeft: "8px",
            paddingRight: "8px",
          }}
        >
          <Space align="center">
            <Image
              src={item.logo}
              alt={item.name}
              preview={false}
              style={{
                width: "20px",
                // filter: "grayscale(100%)", // Apply grey filter
              }}
            />
            <Col>
              <div
                style={{
                  fontSize: "15px",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
              >
                {item.name}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "left",
                  color: "grey",
                }}
              >
                {item.desc}
              </div>
            </Col>
          </Space>
        </List.Item>
      )}
    />
  );
};

export default SkillsList;
